<div class="modal fade" [class.show]="isOpen" [style.display]="isOpen ? 'block' : 'none'" tabindex="-1" role="dialog" aria-modal="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100 text-center text-xl font-bold">Ingresa el código de confirmación</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="close.emit()"></button>
      </div>
      <div class="modal-body">
        <p class="text-center mt-2 text-muted">
          Te enviamos un SMS al número {{ phoneNumber }} con el código de confirmación
        </p>
        <!-- Cronómetro -->
        <div class="text-center my-4">
          <span class="text-sm font-medium">
            {{ timer > 0 ? ('Tiempo restante: ' + timer + ' segundos') : 'Tiempo expirado' }}
          </span>
        </div>
        <!-- Inputs para el código -->
        <div class="d-flex justify-content-center gap-2 my-4">
          <input *ngFor="let digit of code; let i = index"
                 #codeInput
                 type="text"
                 inputmode="numeric"
                 maxlength="1"
                 class="form-control text-center text-xl w-25"
                 [(ngModel)]="code[i]"
                 (keydown)="onKeyDown(i, $event)"
                 style="width: 3rem; height: 3rem; font-size: 1.5rem;" />
        </div>
        <!-- Botones -->
        <div class="d-flex justify-content-between mt-4">
          <button type="button" class="btn btn-outline-secondary" (click)="close.emit()">Cancelar</button>
          <button type="button" class="btn text-white" [ngClass]="{'bg-primary': isCodeCompleteLocal, 'disabled': !isCodeCompleteLocal}" [disabled]="!isCodeCompleteLocal" (click)="onConfirm()">
            Ingresar
          </button>
        </div>
      </div>
    </div>
  </div>
</div> 